import { combineReducers } from "redux";
import { rolesState } from "./rolesReducer";

export const rolesReducer = combineReducers({
  rolesState: rolesState  
});